// Shared navigation model. Lives here because both Navbar (which triggers the
// scroll) and HomePage (which handles arriving with a #hash from another route)
// need the same section list and the same header offset.

// Vertical space the fixed navbar occupies: its wrapper's `pt-3` (12px) plus
// the bar's `h-[4.5rem]` (72px) = 84px, plus 12px of breathing room. Section
// scrolling has to clear it or the heading lands underneath the header.
// Keep in sync with the wrapper/bar classes in components/Navbar.jsx.
export const HEADER_OFFSET = 96;

// Homepage sections, in page order. `hash` matches the section id in the DOM.
export const HOME_SECTIONS = [
  { label: 'Home', hash: '#home' },
  { label: 'Category', hash: '#categories' },
  { label: 'About', hash: '#about' },
  { label: 'Wholesale', hash: '#wholesale' },
  { label: 'Contact', hash: '#contact' },
];

// Standalone pages promoted into the main navbar.
export const PAGE_LINKS = [
  { label: 'Shop', to: '/categories' },
  { label: 'Support', to: '/support' },
];

// Account-menu items shown only when signed in (see Navbar's account dropdown).
export const ACCOUNT_LINKS = [
  { label: 'My Orders', to: '/orders' },
  { label: 'Favourites', to: '/favourites' },
  { label: 'My Account', to: '/account' },
];

// Secondary pages reached from the footer rather than the main navbar, keeping
// the navbar focused on customer navigation.
export const FOOTER_LINKS = [{ label: 'Privacy Policy', to: '/privacy-policy' }];

// Scrolls to a homepage section. Returns true when the target existed, so
// callers can tell a successful in-page scroll from a missing section.
export function scrollToHash(hash) {
  if (!hash) return false;
  const target = document.querySelector(hash);
  if (!target) return false;
  window.scrollTo({ top: target.offsetTop - HEADER_OFFSET, behavior: 'smooth' });
  return true;
}
